var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTicket = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m20.195 9.717.376-.136V6.429H9.43V7a.429.429 0 0 1-.858 0v-.571H3.43V9.58l.376.137a2.429 2.429 0 0 1 0 4.566l-.376.136v3.152H8.57V17a.428.428 0 1 1 .858 0v.571H20.57V14.42l-.376-.137a2.428 2.428 0 0 1 0-4.566Zm-11.498.98a.429.429 0 0 1 .732.303v2a.428.428 0 1 1-.858 0v-2c0-.114.046-.223.126-.303Zm12.606-.394a.428.428 0 0 1-.303.126 1.571 1.571 0 1 0 0 3.142.428.428 0 0 1 .429.429v4a.428.428 0 0 1-.429.429H3A.429.429 0 0 1 2.571 18v-4A.428.428 0 0 1 3 13.571a1.571 1.571 0 1 0 0-3.142.429.429 0 0 1-.429-.429V6A.429.429 0 0 1 3 5.571h18a.428.428 0 0 1 .429.429v4a.428.428 0 0 1-.126.303Z",
  stroke: "currentColor",
  strokeWidth: 1.143
})));

export default SvgTicket;